import type { Tone } from "../../utils/tones";

interface DrumPadProps {
  row: number;
  column: number;
  stepIndex: number;
  drumLabel: string;
  tone: Tone;
  armed: boolean;
  active: boolean;
  onPointerDown: (e: React.PointerEvent<HTMLElement>) => void;
  onPointerEnter: (e: React.PointerEvent<HTMLElement>) => void;
  onPointerUp: (e: React.PointerEvent<HTMLElement>) => void;
}

export function DrumPad({
  row,
  column,
  stepIndex,
  drumLabel,
  tone,
  armed,
  active,
  onPointerDown,
  onPointerEnter,
  onPointerUp,
}: DrumPadProps) {
  const classNames = ["drum-pad"];
  if (armed) classNames.push("is-armed");
  if (active) classNames.push("is-active");
  if (column % 4 === 0) classNames.push("is-downbeat");
  const style = {
    ["--tone" as string]: `var(--${tone})`,
    ["--tone-glow" as string]: `var(--glow-${tone})`,
  } as React.CSSProperties;
  return (
    <button
      type="button"
      className={classNames.join(" ")}
      style={style}
      onPointerDown={onPointerDown}
      onPointerEnter={onPointerEnter}
      onPointerUp={onPointerUp}
      aria-label={`${drumLabel} step ${column + 1}`}
      aria-pressed={armed}
      data-row={row}
      data-column={column}
      data-step={stepIndex}
    >
      <span className="drum-pad-mark" aria-hidden="true" />
    </button>
  );
}
